<template>
  <product-section-card :title="props.title">
    <etg-collapse
      :list="collapseItems"
      divider
      container-class="mt-0"
      header-class="py-0"
      title-class="py-2 text-base font-500 md:font-400"
      :icon-size="10"
      icon-class="p-2"
    />
  </product-section-card>
</template>

<script lang="ts" setup>
import type { CollapseItem } from '@/components/global/etg-collapse.vue'
import ProductSectionCard from '@/components/product/product-detail/product-section-card.vue'

import type { FbranchPAAQA } from '@/types/api'

interface Props {
  title: string
  paaItems: FbranchPAAQA[]
}

const props = defineProps<Props>()

const collapseItems = computed<CollapseItem[]>(() =>
  props.paaItems
    .filter(item => item.question && item.answer)
    .map(item => ({
      title: item.question!,
      content: item.answer!,
    }))
)
</script>

<style lang="scss" scoped>
:deep(.n-collapse) {
  .n-collapse-item {
    .n-collapse-item__header {
      @apply py-2;
    }

    .n-collapse-item__content-inner {
      @apply pt-2;
    }
  }
}
</style>
